import * as modalTypes from "../../../../constants/modalTypes";
import * as objectTypes from "../../../../constants/objectTypes";
import * as optionHelper from "../../../../helpers/optionHelper";
import * as propertyConstants from "../../../../constants/propertyConstants";
import * as translationHelper from "../../../../helpers/translationHelper";

import { File, createEmptyFile, generateFileData, generateFileHeadings } from "../../../../types/file";
import React, { Component } from "react";

import { FileCategory } from "../../../../types/fileCategory";
import { FileType } from "../../../../types/fileType";
import { ModalParams } from "../../../../types/modalParams";
import { ModalProperties } from "../../../../types/modalProperties";
import { TableContainer } from "../../../Table";
import { TableHeading } from "../../../../types/tableHeading";

import { t as translate } from "react-i18nify";

type Props = {
    tableConstant: string;
    objectType: objectTypes.ObjectType;
    dataPrivileges: any;
    loading: boolean;
    buttonLoading: boolean;
    categoryList: Array<FileCategory>;
    fileTypeList: Array<FileType>;
    allList: Array<File>;
    activeList: Array<File>;
    columnOrder: Array<propertyConstants.Property>;
    columnVisibility: Record<propertyConstants.Property, boolean>;
    columnWidth: Record<propertyConstants.Property, number>;
    offset: number;
    page: number;
    rowCount: number;
    rowCountCustom: boolean;
    search: string | null;
    searchParams: Record<propertyConstants.Property, string>;
    showFilterRow: boolean;
    showGlobalSearch: boolean;
    sortingAsc: boolean;
    sortingCriterion: propertyConstants.Property | null;
    totalCount: number | null;
};

export class StaticSqlTable extends Component<Props> {
    generateTableHeadings = (modalType: modalTypes.ModalType | null = null): Array<TableHeading> => {
        const propertyList: Array<propertyConstants.Property> = [propertyConstants.PROPERTY_NAME];
        const requiredList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_FILE_TYPE_ID,
            propertyConstants.PROPERTY_NAME
        ];
        const alwaysVisibleList: Array<propertyConstants.Property> = [];
        const editableList: Array<propertyConstants.Property> = [...propertyList];
        let visibleList: Array<propertyConstants.Property> = [...propertyList];

        visibleList.splice(1, 0, propertyConstants.PROPERTY_URL);

        if (modalType === null) {
            visibleList.splice(1, 0, propertyConstants.PROPERTY_LENGTH);
        }

        if (modalType !== null) {
            visibleList.splice(1, 0, propertyConstants.PROPERTY_FILE);
            editableList.push(propertyConstants.PROPERTY_URL);
            editableList.push(propertyConstants.PROPERTY_FILE);
        }

        if (modalType === modalTypes.MODAL_FILES_EDIT) {
            visibleList.splice(1, 0, propertyConstants.PROPERTY_LENGTH);
        }

        let orderList = [...visibleList];

        if (modalType === null) {
            orderList = optionHelper.handleTableHeadingOrder(visibleList, this.props.columnOrder);
            visibleList = optionHelper.handleTableHeadingVisibility(visibleList, this.props.columnVisibility);
        }

        return generateFileHeadings(
            this.props.objectType,
            this.props.fileTypeList,
            this.props.categoryList,
            orderList,
            visibleList,
            editableList,
            requiredList,
            alwaysVisibleList,
            this.props.columnWidth
        );
    };

    generateAddModalParams = (): ModalParams => {
        return new ModalParams(
            modalTypes.ADD_MODAL,
            this.props.objectType,
            translate("file.addFile"),
            createEmptyFile(this.props.fileTypeList),
            this.generateTableHeadings(modalTypes.MODAL_FILES_ADD)
        );
    };

    generateEditModalParams = (): ModalParams | null => {
        const activeData = generateFileData(this.props.activeList);

        if (activeData.length) {
            return new ModalParams(
                modalTypes.EDIT_MODAL,
                this.props.objectType,
                translate("file.editFile"),
                activeData[0],
                this.generateTableHeadings(modalTypes.MODAL_FILES_EDIT)
            );
        }

        return null;
    };

    render(): JSX.Element {
        const { objectType } = this.props;

        const modalProperties: ModalProperties = {
            addModalType: modalTypes.MODAL_FILES_ADD,
            addModalParams: this.generateAddModalParams(),
            editModalType: modalTypes.MODAL_FILES_EDIT,
            editModalParams: this.generateEditModalParams(),
            fileCategoriesModalType: modalTypes.MODAL_FILE_CATEGORIES_TABLE,
            fileCategoriesModalParams: { objectType: objectType }
        };

        return (
            <div className="height-100">
                <TableContainer
                    className={"table-with-filter"}
                    tableConstant={this.props.tableConstant}
                    objectType={objectType}
                    dataPrivileges={this.props.dataPrivileges}
                    loading={this.props.loading}
                    buttonLoading={this.props.buttonLoading}
                    title={translationHelper.getTitleSectionTranslation(this.props.objectType)}
                    titleClassName={"main-title"}
                    headings={this.generateTableHeadings()}
                    data={generateFileData(this.props.allList)}
                    activeData={this.props.activeList}
                    offset={this.props.offset}
                    page={this.props.page}
                    rowCount={this.props.rowCount}
                    rowCountCustom={this.props.rowCountCustom}
                    search={this.props.search}
                    searchParams={this.props.searchParams}
                    showFilterRow={this.props.showFilterRow}
                    showGlobalSearch={this.props.showGlobalSearch}
                    sortingAsc={this.props.sortingAsc}
                    sortingCriterion={this.props.sortingCriterion}
                    totalCount={this.props.totalCount}
                    modalProperties={modalProperties}
                />
            </div>
        );
    }
}
